<div class="snack-body">
  <span matSnackBarLabel>
    <div class="snack-label">{{ data.message }}</div>
  </span>
  <span matSnackBarActions>
    <button
      id="snack-action"
      class="snack-action"
      [ngClass]="data.type"
      mat-button
      matSnackBarAction
      (click)="snackBarRef.dismissWithAction()"
    >
      {{ data.actionLabel }}
    </button>
  </span>
</div>
